import { ref } from 'vue';
export default function systemVersion() {
  const appVersion = ref('Version 6.7.127');
  return { appVersion };
}
